import React, { createContext, useContext } from 'react';

const RBACContext = createContext();

export const RBACProvider = ({ userPermissions, children }) => {
  // userPermissions structure: { 'sales_module': ['read', 'write'], 'settings': ['read'] }

  const hasPermission = (module, action) => {
    if (!userPermissions) return false;
    const modulePerms = userPermissions[module];
    return modulePerms && modulePerms.includes(action);
  };

  return (
    <RBACContext.Provider value={{ hasPermission }}>
      {children}
    </RBACContext.Provider>
  );
};

// Reusable Hook
export const usePermission = () => useContext(RBACContext);